import styled from 'styled-components'
import { media, rgba, colors, radiuses } from 'styles'

const StyledAvatarList = styled.div`
  flex: 1 0 40%;

  .profile-image {
    cursor: pointer;
    margin-bottom: 1rem;
    position: relative; // needed for username--mobile
    border-radius: ${radiuses.large};
    overflow: hidden;
  }
  .gallery {
    display: flex;

    .item {
      position: relative;
      width: 30%;
      cursor: pointer;
      overflow: hidden;
      &:nth-child(2) {
        margin: 0 5%;
      }

      // Don't show 'upgrade for xxx' text in gallery items
      .avatar-text {
        padding-bottom: 0;
      }
      .avatar-upgrade {
        display: none;
      }
    }

    .show-all {
      position: absolute;
      display: flex;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;
      text-align: center;
      width: 100%;
      height: 100%;
      z-index: 1;
      text-decoration: underline;
      background: ${rgba(colors.main, 0.6)};
      color: ${colors.mainInverted};
      border-radius: ${p => (radiuses[p.size] || radiuses.large)(p)};
      font-size: 1.2rem;
    }
  }

  ${media.phone`
    .profile-image {
      position: relative;
      margin-bottom: 2rem;
    }
  `}
`

export default StyledAvatarList
